import SeasonSelect from "@/components/SeasonSelect.vue";
import AnnualEvaRate from "@/components/AnnualEvaRate.vue";

import { getSeason } from "../utils/utilApi";
import { evaResultTable, evaResultTable2 } from "../data/EvaResultDisplay";
import { post } from "../utils/request";
import { SPECIAL_SCORE } from "../utils/utilData";
import { ElMessage } from "element-plus";
import { ORGANIZATION_ACCOUNT } from "../utils/utilData";

import { BUREAU_MANAGE, PARTY_GROUP } from "../utils/utilData";

import FileSaver from "file-saver";
import * as XLSX from 'xlsx'

export default {
  data() {
    return {
      showableComp: {
        evaResultForm: false,
        specialEvaForm: false,
        exportTable: false,
      },
      disabled: {
        yearEvaBtn: false,
      },
      evaResultTable: [],
      evaResultList: [],
      year: String(new Date().getFullYear()),
      season: getSeason(),
      currentPage: 1,
      pagesize: 10,
      resultForm: {
        userId: "",
        username: "",
        regionName: "",
        departmentName: "",
        totalScore: "",
        level: "",
        rank: "",
      },
      specialScoreForm: {
        userId: "",
        score: "",
        remarks: "",
      },
      row: "",
      searchKeyWord: "", // 搜索框
      newColumn: false, // 是否已年度考评？
    }
  },
  components: { SeasonSelect, AnnualEvaRate },
  name: "EvaResultDisplay",
  methods: {
    // 切换每页显示数据
    handleSizeChange(val) {
      this.pagesize = val;
      // console.log(`每页 ${val} 条`);
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(`当前页: ${val}`);
    },
    // 取消本次考核成绩
    doUpdate(index, row) {
      let data ={
        userId: row.userId,
        year: this.year,
        season: this.season
      }
      post("/updatescore", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.evaResultSearch();
        }
      });
    },
    // 开启年底考核
    yearEva() {
      if (this.newColumn) {
        return;
      }
      this.evaResultTable.push({
        label: "年度考评",
        prop: "annualRate",
        fixed: "right",
      })
      for (let i = 0; i < this.evaResultList.length; i++) {
        this.evaResultList[i].isOk = true;
      }
      this.newColumn = true;
      this.$refs.multipleTable.doLayout();
    },
    /**
     * @description 保存年度考核等次
     * @function POST /evaRate/annual/save
     * 
     * @param {int} year 年度
     * @param {Object[]} annualRateList 年度考核数据集合
     * @param {String} annualRateList[].annualRate 年度考核等次
     * @param {int} annualRateList[].userId 用户ID
     * 
     */
    saveYearEva() {
      let data = {
        year: this.year,
      }
      let annualRateList = [];
      for (let i = 0; i < this.evaResultList.length; i++) {
        annualRateList.push({ userId: this.evaResultList[i].userId, annualRate: this.evaResultList[i].annualRate })
        // this.evaResultList[i].isOk = true;
      }
      data.annualRateList = annualRateList;
      console.log(data);
      post("/evaRate/annual/save", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          for (let i = 0; i < this.evaResultList.length; i++) {
            this.evaResultList[i].isOk = false;
          }
        }
      });
    },
    /**
     * @description 查询所有人员的最终考评分数、考核等次等信息。要注意参数要查询子集。该功能可能由科室长、分管领导、局管理、组织部汇总账号查看（组织部汇总账号还没做）。不同权限的人查询到的人员是不同的
     * @function POST /eva/result/search
     * 
     * @param {int} regionId 所属地区Id
     * @param {int} departmentId 科室Id
     * @param {int} year 年
     * @param {String} season 季度
     * @param {Boolean} organization 是否是组织部账号
     * 
     * @returns evaResultList[]，其中的每一项包含的元素如下
     * @returns userId用户Id, username姓名, departmentName部门名称, regionName所属地区, totalScore最终得分, level考核等次, rank排名, commonScore共性指标得分, taskScore个性指标得分, attendanceScore考勤得分, specialScore党委得分, bureauName单位名称
     */
    evaResultSearch() {
      let data = {
        regionId: JSON.parse(sessionStorage.getItem("regionInfo")).regionId,
        departmentId: JSON.parse(sessionStorage.getItem("departmentInfo")).departmentId,
        year: this.year,
        season: this.season,
        organization: false,
      }
      // 如果是组织部汇总账号，则查询所有单位所有部门的人
      if (JSON.parse(sessionStorage.getItem("roleList"))[0].roleId == ORGANIZATION_ACCOUNT) {
        data.organization = true;
      }
      post("/eva/result/search", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.evaResultList = JSON.parse(res.data.evaResultList);
          console.log(JSON.parse(res.data.evaResultList));
        }
      });
    },
    // 点击党委打分
    handleSpecialEva(index, row) {
      this.specialScoreForm.userId = row.userId;
      this.specialScoreForm.year = this.year;
      this.specialScoreForm.season = this.season;
      this.row = row;
      this.showableComp.specialEvaForm = true;
    },
    /**
     * @description 提交党委打分
     * @function POST /specialScore/add
     * 
     * @param {int} userId 用户ID
     * @param {int} year 年度
     * @param {String} season 季度
     * @param {int} score 扣分数
     * @param {String} remarks 备注
     */
    specialScoreSubmit() {
      if (this.specialScoreForm.score > SPECIAL_SCORE) {
        ElMessage.error("党委打分不能扣超过" + SPECIAL_SCORE + "分", {
          duration: 3 * 1000,
        });
        return;
      }
      post("/specialScore/add", JSON.stringify(this.specialScoreForm)).then((res) => {
        if (res.code == 200) {
          this.row.specialScore = SPECIAL_SCORE - this.specialScoreForm.score;
          this.row.totalScore = this.row.totalScore - this.specialScoreForm.score;
        }
      });
      this.showableComp.specialEvaForm = false;
    },
    doCancel() {
      this.showableComp.specialEvaForm = false;
    },
    // 导出成绩
    exportRes() {
      /* generate workbook object from table */
      var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#exportTable'), xlsxParam);

      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), this.searchKeyWord + '考评成绩表.xlsx');
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout);
        }
      }
      return wbout;
    }
  },
  created() {
    this.evaResultTable = evaResultTable;
    // this.evaResultList = evaResultList;
    this.evaResultSearch();
  },
  watch: {
    year() {
      this.evaResultSearch();
    },
    season() {
      if (this.season == '全年') {
        this.evaResultTable = evaResultTable2;
        this.disabled.yearEvaBtn = false;
      } else {
        this.evaResultTable = evaResultTable;
        this.disabled.yearEvaBtn = true;
      }
      this.evaResultSearch();

    }
  },
  computed: {
    specialRole() {
      let roleList = JSON.parse(sessionStorage.getItem("roleList"));
      let flag = false;
      for (let i = 0; i < roleList.length; i++) {
        // 只有局党组账号才能在展示页面进行党委评分
        if (roleList[i].roleId == PARTY_GROUP) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    bureauManage() {
      let roleList = JSON.parse(sessionStorage.getItem("roleList"));
      let flag = false;
      for (let i = 0; i < roleList.length; i++) {
        // 只有局党组账号才能在展示页面进行党委评分
        if (roleList[i].roleId == BUREAU_MANAGE) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    filteredData() {
      return this.evaResultList.filter(data => !this.searchKeyWord || data.username.toLowerCase().includes(this.searchKeyWord.toLowerCase()) || data.departmentName.toLowerCase().includes(this.searchKeyWord.toLowerCase()) || data.bureauName.toLowerCase().includes(this.searchKeyWord.toLowerCase()))
    }
  }
}